import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericResModel } from 'countable@model';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PartnerService {

  private readonly SAVE_ENG_PARTNERSHIP_SETTING = environment.apiV1 + '/eng-partnership-setting';
  private readonly SAVE_PARTNERSHIP_ACCOUNT = environment.apiV1 + '/partnership-account';
  private readonly SAVE_ADD_PARTNERS_CAPITAL = environment.apiV1 + '/add-partnership-capital';
  private readonly UNGROUP_PARTNERSHIP = environment.apiV1 + '/ungroup-partnership';

  constructor(private http: HttpClient) {
  }

  public saveEngPartnerShipSetting(data: string): Observable<GenericResModel<boolean>> {
    return this.http.post<GenericResModel<boolean>>(this.SAVE_ENG_PARTNERSHIP_SETTING, data);
  }

  public savePartnerShipAccount(data: string): Observable<GenericResModel<boolean>> {
    return this.http.post<GenericResModel<boolean>>(this.SAVE_PARTNERSHIP_ACCOUNT, data);
  }

  public saveAddPartnersCapital(data: string): Observable<GenericResModel<boolean>> {
    return this.http.post<GenericResModel<boolean>>(this.SAVE_ADD_PARTNERS_CAPITAL, data);
  }

  public ungroupPartnerShip(data: string): Observable<GenericResModel<boolean>> {
    return this.http.put<GenericResModel<boolean>>(this.UNGROUP_PARTNERSHIP, data);
  }
}
